import React, { useCallback, useEffect } from "react";
import JobConfigView from "../../../components/JobConfigView";
import { TableColumn } from "../../../components/Table";
import { JobType } from "../../../constants/JobTypes";
import { fetchJobConfigMMM, fetchJobRunMMM } from "../../../redux/jobMMMSlice";
import { AppDispatch, RootState } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/Loader";

const columns: TableColumn[] = [
  { key: "name", label: "Name" },
  {
    key: "createdDate",
    label: "Created Date",
    formatter: {
      type: "date",
    },
  },
  { key: "action", label: "Action" },
];

const nbaBreadCrumbs = [
  {
    name: "Home",
    url: "/",
  },
  {
    name: "Measurement",
    url: "/planning/marketing-mix-model-landing",
  },
  {
    name: "Marketing Mix Model",
    url: "/planning/marketing-mix-model",
  },
];

const MarketingMixModel: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { jobConfigList, jobRunList, loading } = useSelector(
    (state: RootState) => state.jobMMM
  );

  useEffect(() => {
    dispatch(fetchJobConfigMMM());
    dispatch(fetchJobRunMMM());
  }, [dispatch]);

  const handleRefresh = useCallback(() => {
    dispatch(fetchJobConfigMMM());
    dispatch(fetchJobRunMMM());
  }, [dispatch]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <JobConfigView
          jobConfigList={jobConfigList}
          jobRunList={jobRunList}
          breadCrumbs={nbaBreadCrumbs}
          tableColumns={columns}
          jobType={JobType.MarketingMixModel}
          onRefresh={handleRefresh}
        />
      )}
    </>
  );
};

export default MarketingMixModel;
